class FetchBeneficiaryTypeGrants {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchBeneficiaryTypeGrants;
